import * as React from "react";
import { CustomerTypeArrays, CustomerTypeArraysMap, titleLabels } from "../../Resource/Contents";
import { RadioGroup } from "../../../../../../../react-core/Html/RadioGroup";
import { validationMessage } from "../../Resource/Validation";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";

interface IClientTypeSelectionProps extends IProcessComponentProps {}

interface IClientTypeSelectionState {}

export class ClientTypeSelection extends ProcessComponent<IClientTypeSelectionProps, IClientTypeSelectionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <>
                <RadioGroup
                    cssWrapper={"mt-40 control-size-430"}
                    label={titleLabels.clientType}
                    tooltip={"Content TBC"}
                    options={CustomerTypeArrays}
                    getText={(option) => {
                        return CustomerTypeArraysMap[option];
                    }}
                    onChange={(value) => this.props.onChange(value)}
                    required={validationMessage.clientTypeValidation}
                    selected={this.props.data}
                />
            </>
        );
    }
}
